export default __webpack_public_path__ + "static/IMG_20190428_140824-b95d50717aa7f6a7a576860451404599.jpg";